import {
  Parser,
  Skipper,
  parserFor,
} from './common';

export class Without<T, U> implements Parser<T> {
  public constructor(private readonly parser: Parser<T>, private readonly except: Parser<U>) { }
  public parse(str: string) {
    const { parser, except } = this;
    const r = parser.parse(str);
    if (r !== undefined) {
      const w = except.parse(str.slice(0, str.length - r.next.length));
      if (w === undefined || w.next.length !== 0) {
        return r;
      }
    }
  }
}

export function without<T, U>(parser: Parser<T>, except: Parser<U>, skip?: Skipper): Without<T, U>;
export function without<T>(parser: Parser<T>, except: any, skip?: Skipper): Without<T, any>;
export function without<T>(parser: any, except: Parser<T>, skip?: Skipper): Without<any, T>;
export function without(parser: any, except: any, skip?: Skipper): Without<any, any>;
export function without(parser: any, except: any, skip?: Skipper): Without<any, any> {
  return new Without(parserFor(parser, skip), parserFor(except, skip));
}
